import React, {
  useState,
  Component,
  useRef,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import styled from "styled-components";
import LineDivider from "../LineDivider";
import LoadMoreArrow from "../../../../assets/imgs/icons/load-more-arrow.svg";
import Color from "color";

const checkboxTick = require("../../../../assets/imgs/checkbox_tick.png");
const checkboxUntick = require("../../../../assets/imgs/uncheck.png");
let maxCount = 0;
let userSelectedCheckbox = [];

const months = [
  "",
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  " Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const AllTransactionDetails = (props) => {

  const buttonStyleEnabled = { background: "#003E8D", pointerEvents: "auto" };
  const buttonStyleDisabled = { background: "#a8aad3", pointerEvents: "none" };

  const [flag, setFlag] = useState(true);

  const [checkBlockPointer, setCheckBlockPointer] = useState("auto");
  const [buttonStyle, setButtonStyle] = useState(buttonStyleEnabled);

  const [showCount, setShowCount] = useState(10); //for view more
  // const [isDisabled,setIsDisabled] = useState("auto"); //disable pointer-events css
  const transactionsResponse = props.transactionsResponse;
  let userSelected = [];


  const disableButtons = (isDisabled) => {
    if (isDisabled) {
      setButtonStyle(buttonStyleDisabled);
      setCheckBlockPointer("none");
    } else {
      setButtonStyle(buttonStyleEnabled);
      setCheckBlockPointer("auto");
    }
  };

  const handleProceed = () => {

    if (userSelected.length == 0) {
      props.overlayMessageToggle("Please select atleast 1 transaction");
    } else {
      let inputString =
        "Convert to EMI" + "<split>" + JSON.stringify(userSelected);
      window["autosubmit"](inputString);

      setButtonStyle(buttonStyleDisabled);
      setCheckBlockPointer("none");

      setFlag(false);
      props.storeChecklist(userSelected); //jithin
      userSelected = [];
      maxCount = 0;
      // userSelectedCheckbox = [];

    }
  };

  const handleCheckboxChange = (selectedTranscation) => {
  
    if (userSelected.includes(selectedTranscation.transactionNo) == false && maxCount < 3) {
      userSelected.push(selectedTranscation.transactionNo);
      userSelectedCheckbox = userSelected;
      //console.log("data added");
    } else {
      var index = userSelected.indexOf(selectedTranscation.transactionNo); // changed from selectedTranscation to selectedTranscation.transactionNo 02_05_2024 (3 places)
      if (index >= 0) {
        userSelected.splice(index, 1);
        // console.log("data removed");
      }
    }

    //console.log(userSelected);
  };

  //css
  //
  const ButtonProceed = styled.div`
    width: 92%;
    margin: 12px;
    border-radius: 4px;
    color: #fff;
    text-align: center;
    line-height: 36px;
    cursor: pointer;
    pointer-events: ${buttonStyle.pointerEvents};
    background: ${buttonStyle.background};
  `;
  //***

  const showMiniStatement = () => {
    //css
    // pointer-events:${isDisabled};
    const MiniStatement = styled.div`
      display: flex;
      flex-direction: column;
      margin: 12px 12px 0px 12px;
      border: 1px solid #fcfcfc;
      border-radius: 4px;
      box-shadow: 0px 5px 12px rgba(0, 0, 0, 0.2);
      background: #fcfcfc;
      font-size: 13px;

      & .block-header {
        padding: 10px;
        border-bottom: 0.5px dashed #dedede;
        font-weight: 500;
        color: #003e8d;
      }

      & .block-footer {
        display: flex;
        justify-content: space-between;
        padding: 10px 10px;
        color: #282828;
        > div:first-child {
          margin-right: 15px;
        }
      }

      & .date {
      }

      & .desc {
        width: 160px;
      }

      & .value {
        font-weight: 500;
        display: inline-block;
        position: absolute;
        right: 38px;
        font-size: 14px;
      }
    `;
    //***
    return (
      <div
        style={{ pointerEvents: `${checkBlockPointer}` }}
        id="transactionResponseDetail"
      >
        {transactionsResponse.slice(0, showCount).map((item, i) => {
          let date =
            months[parseInt(item.recordDate.substring(4, 6))] +
            " " +
            item.recordDate.substring(6, 8) +
            ", " +
            item.recordDate.substring(0, 4);
 
          return (
            <React.Fragment key={i}>
              <MiniStatement
                id="transactionList"
                // onClick={()=> handleOnClick(item)}
              >
                <div className="block-header">
                  <CheckBox
                    label={date}
                    handleClick={() => handleCheckboxChange(item)}
                    overlayMessageToggle={props.overlayMessageToggle}
                    checkBoxId={item.amosAmxtKey}
                    checkBoxId2={item.amssAmslKey}
                    some={
                      props.checkList ? props.checkList : userSelectedCheckbox //jithin
                      //   userSelectedCheckbox
                    }
                    flag={flag}
                  />
                </div>

                <div className="block-footer">
                  <div className="desc">{item.narrative}</div>
                  <div className="value">
                    ₹ {item.amount.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,")}
                    {/* ₹ {debitAmount.replace(/(\d)(?=(\d\d)+\d$)/g, "$1,") + "." + floatAmount}*/}
                  </div>
                </div>
              </MiniStatement>

              {i !== transactionsResponse.length - 1}
              {showCount < transactionsResponse.length && i === showCount - 1 && (
                <LoadMore onClick={() => setShowCount(showCount + 10)}>
                  Load More <img src={LoadMoreArrow} alt="load more icon" />
                </LoadMore>
              )}
            </React.Fragment>
          );
        })}
      </div>
    );
  };
  return (
    <React.Fragment>
      {showMiniStatement()}

      <ButtonProceed id="ConvertToEMI" onClick={() => handleProceed()}>
        Convert to EMI
      </ButtonProceed>
    </React.Fragment>
  );
};
//
/************************************  TestAllTrComponent ******************************************************/

//  class TestComponent extends Component{
//         constructor(props) {
//             super(props);
//             this.state = {
//             };
//           }
//         render(){
//             return(
//                 <div></div>
//             );
//         }
//  }

/* ****************************  TestComponent ******************************************************/
//
class CheckBox extends Component {
  shouldComponentUpdate = () => this.props.some;

  constructor(props) {
    super(props);
    this.state = {
      //  backgroundColor:'',
      backgroundImage: checkboxUntick,
      isChecked: false,
      //  isDisabled:"auto"
    };

    this.some = this.props.some;
    this.someFlag = true;
  }

  componentDidMount() {
   // console.log(this.some)
    if (
      this.some.filter(
        (data) =>
          data.amosAmxtKey === this.props.checkBoxId &&
          data.amssAmslKey === this.props.checkBoxId2
      ).length !== 0
    ) {
      this.setState({
        backgroundImage: checkboxTick,
        isChecked: false,
      });

      this.someFlag = false;
    }
  }

  // componentWillReceiveProps(){

  //    // this.showEMIdetail2 = this.props.showEMIdetail;
  //    if(this.some.filter(data => data.amosAmxtKey === this.props.checkBoxId).length !== 0){

  //     this.setState({
  //      backgroundImage:checkboxTick,
  //      isChecked:false,
  //     })
  // }

  // }

  handleCheckState = () => {
    if (this.state.isChecked == false) {
      if (maxCount < 3) {
        this.setState({
          isChecked: true,
          backgroundImage: checkboxTick,
        });
        maxCount++;
      } else {
        this.props.overlayMessageToggle(
          "You can select upto 3 transcations only"
        );
      }
    } else {
      this.setState({
        isChecked: false,
        backgroundImage: checkboxUntick,
      });
      maxCount--;
    }

    //    this.setState({
    //        isDisabled: "none"
    //    })
  };

  render() {
    //pointer-events:${this.state.isDisabled};

    const CheckBox_Block = styled.div`
      cursor: pointer;
    `;
    const BoxBlock = styled.div`
    // background: ${this.state.backgroundColor};
    background: url(${this.state.backgroundImage});
    display:inline-block;
    vertical-align:middle;
    width: 15px;
    height: 15px;
    // border-radius: 2px;
    // border: solid 1px #666666;
   // background-color: #ffffff;


    `;
    const TextBlock = styled.div`
      width: 100px;
      // background: yellow;
      color: "black";
      margin-left: 10px;
      display: inline-block;
      vertical-align: middle;
    `;
    return (
      <CheckBox_Block
        onClick={() => {
          this.props.handleClick();
          this.handleCheckState();
        }}
      >
        <BoxBlock />
        <TextBlock>{this.props.label}</TextBlock>
      </CheckBox_Block>
    );
  }
}

const LoadMore = styled.div`
  color: #707070;
  text-align: center;
  margin-top: 8px;
  cursor: pointer;
  img {
    margin-left: 2px;
    vertical-align: middle;
  }
`;

export default AllTransactionDetails;
